module.exports = __webpack_public_path__ + "static/media/center.07840b2a.svg";